import { Route, Routes } from 'react-router-dom';

import { Dashboard } from './dashboard/Dashboard';
import { PlansView } from './plans';
import { PortalShell } from './shell/PortalShell';
// Seam owned by Dev-D: web/src/platform/tenants/index.tsx MUST export these two
// route components by exactly these names.
import { TenantDetailRoute, TenantsRoute } from './tenants';

/**
 * Platform-admin console route table. {@link PortalShell} is the layout route
 * (rail + command bar + breadcrumbs) and each child renders into its `Outlet`:
 *   `/`               → Dashboard
 *   `/tenants`        → Tenants resource list (Dev-D)
 *   `/tenants/:id`    → Tenant detail (Dev-D)
 *   `/plans`          → Subscription-tier catalog (read-only)
 */
export function PlatformRoutes(): JSX.Element {
  return (
    <Routes>
      <Route element={<PortalShell />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/tenants" element={<TenantsRoute />} />
        <Route path="/tenants/:id" element={<TenantDetailRoute />} />
        <Route path="/plans" element={<PlansView />} />
      </Route>
    </Routes>
  );
}
